import React, { useState, useRef } from 'react';
import './FallingLetters.css';
import { useSigilContext } from '../../context/sigilContext';

const FallingLettersTextBox = () => {
  const [cursorPosition, setCursorPosition] = useState(0);
  const inputRef = useRef(null);

  const {
    setOriginalText,
    text,
    setText,
    fallingLetters,
    i18n
  } = useSigilContext()

  const updateCursor = (e) => {
    setCursorPosition(e.target.selectionStart || 0);
  };

  const handleChange = (e) => {
    setOriginalText(e.target.value)
    setText(e.target.value);
    updateCursor(e);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      processText();
    }
  };

  const processText = () => {
    const uniqueLetters = [...new Set(text.toLocaleUpperCase().split(''))];
    setText(uniqueLetters.join(''));
    // Al procesar, el cursor suele ir al final
    setCursorPosition(uniqueLetters.length);
  };

  const translate = i18n.creation;

  // Sincronizar cursor al enfocar
  const handleFocus = (e) => {
    updateCursor(e);
  };

  const handleLetterClick = (index, e) => {
    e.stopPropagation(); // Evitar el click general del text-box
    const newPos = index;
    setCursorPosition(newPos);
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.setSelectionRange(newPos, newPos);
    }
  };

  const handleBoxClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
      // Si se hace click en el contenedor pero no en una letra, poner el cursos al final
      const endPos = text.length;
      inputRef.current.setSelectionRange(endPos, endPos);
      setCursorPosition(endPos);
    }
  };

  return (
    <div className="text-box-container">
      <div className="text-box" onClick={handleBoxClick}>
        {text.length === 0 && (
          <span className="text-letter falling-initial" style={{ color: '#D9D9D980', overflow: 'auto' }}>
            {translate.placeholderBox}
          </span>
        )}

        {/* Renderizado de letras con cursor dinámico */}
        {text.split('').map((letter, index) => (
          <React.Fragment key={index}>
            {cursorPosition === index && <span className="custom-cursor" />}
            <span
              className="text-letter falling-initial clickable-letter"
              onClick={(e) => handleLetterClick(index, e)}
            >
              {letter}
            </span>
          </React.Fragment>
        ))}
        {/* Cursor al final si está en esa posición */}
        {cursorPosition === text.length && text.length > 0 && (
          <span className="custom-cursor" />
        )}

        {fallingLetters.map(({ letter, index }) => (
          <span
            key={index}
            className="falling-letter"
            style={{ left: `${index * 16}px` }}
          >
            {letter}
          </span>
        ))}
      </div>
      <input
        ref={inputRef}
        type="text"
        value={text}
        onChange={handleChange}
        onKeyDown={handleKeyPress}
        onKeyUp={updateCursor}
        onSelect={updateCursor}
        onClick={updateCursor}
        onFocus={handleFocus}
        placeholder={translate.placeholderBox}
        className="hidden-input"
      />
    </div>
  );
};

export default FallingLettersTextBox;

